<template>
  <div class="building-detail">
    <div class="building-detail__header">
      <div
        class="building-detail__header--back"
        @click="navBack()"
      >&lt; {{ $t('back') }}</div>
      <div class="building-detail__header--btn">
        <button
          class="btn btn--darkblue"
          @click="cancel"
          v-if="isEditing && tid !== 'createTemplate'"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn btn--orange"
          @click="addOneTemplateChip"
          v-if="isEditing"
        >{{ $t('action.add') }}</button>
        <button
          class="btn btn--orange"
          @click="save"
          v-if="isEditing"
        >{{ $t('action.save') }}</button>
        <button
          class="btn btn--orange"
          @click="edit"
          v-if="!isEditing && isEditShow"
        >{{ $t('action.edit') }}</button>
      </div>
    </div>

    <div class="building-detail__tabs">
      <TabsContainer
        :tabNames="tabNames"
        class="building-detail__tabs--header"
        :getCurrentTab="getCurrentTab"
      >
        <building-template
          slot="tab-0"
          ref="tab-0"
          :isEditing="isEditing"
        />
      </TabsContainer>
    </div>
  </div>
</template>

<script>
import TabsContainer from '@/controls/TabsContainer'
import BuildingTemplate from '@/modules/settings/engineers/BuildingTemplate'
import { aclHelper } from '@/utils/aclHelper'

export default {
  name: 'BuildingDetail',
  components: {
    TabsContainer,
    BuildingTemplate,
  },
  data () {
    const tabNames = [this.$t('settings.engineers.buildingTemplate.template')]
    return {
      tabNames,
      isEditing: false,
      currentTabIndex: 0,
    }
  },
  computed: {
    isEditShow () {
      return aclHelper.getSettingsUpdateAccess()
    },
  },
  methods: {
    navBack () {
      this.$router.goBack()
    },
    edit () {
      this.isEditing = true
    },
    switchEditState () {
      this.isEditing = !this.isEditing
    },
    async save () {
      const ret = await this.$refs[`tab-${this.currentTabIndex}`].save()
      if (ret) {
        this.switchEditState()
      }
      this.tid = this.$router.currentRoute.params.tid
    },
    getCurrentTab (index) {
      this.currentTabIndex = index
    },
    async cancel () {
      this.isEditing = false
      await this.$refs[`tab-${this.currentTabIndex}`].cancel()
    },
    async addOneTemplateChip () {
      await this.$refs[`tab-${this.currentTabIndex}`].addOneTemplateChip()
    },
  },
  mounted () {
    this.tid = this.$router.currentRoute.params.tid
    if (this.tid === 'createTemplate') {
      this.isEditing = true
    }
  },
}
</script>

<style lang="scss" scoped>
.building-detail {
  background-color: #FAFBFC;
  max-width: 1440px;
  margin: 0 auto;
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 69px;
    background-color: #ffffff;
    box-shadow: 0 0 4px 0 rgba(172, 172, 172, 0.5);
    padding: 0 15px;
    &--back {
      width: 60px;
      height: 20px;
      font-size: 14px;
      color: #1a557d;
      cursor: pointer;
    }
    &--title {
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: #0c3a58;
    }
  }

  &__tabs {
    margin-top: 10px;
    margin-left: 15px;
  }

}
</style>
<style lang="scss">
.building-detail__tabs--header {
  ul#common-tabs {
    display: inline-block;
    background-color: #FAFBFC;
    width: 100%;
    border-bottom: 2px solid #ededed;
    li.tabs-title a {
      width: 280px;
      background-color: #FAFBFC;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .hkld-tabs-content {
    background-color: none;
  }
  .create-project-main .tabs-panel {
    background-color: #FAFBFC;
  }
}
</style>
